import { useMediaQuery } from 'react-responsive';
import math from 'polished/lib/math/math';
import useTheme from './useTheme';

const useViewport = () => {
    const { theme } = useTheme();
    const isXSMobile = useMediaQuery({
        maxWidth: math(`${theme.breakpoints.xs} - 1px`),
    });
    const isMobile = useMediaQuery({
        maxWidth: math(`${theme.breakpoints.sm} - 1px`),
    });
    const isTablet = useMediaQuery({
        minWidth: theme.breakpoints.sm,
        maxWidth: math(`${theme.breakpoints.lg} - 1px`),
    });
    const isDesktop = useMediaQuery({ minWidth: theme.breakpoints.lg });

    return {
        isDesktop,
        isTablet,
        isMobile,
        isXSMobile,
    };
};

export default useViewport;
